import { DragOverlay, useDndMonitor } from "@dnd-kit/core";
import { useDndSortContext } from "./DndSortContext";
import styles from "../../Dnd/Dnd.module.scss";
import cx from "classnames";
import { useEffect, useState } from "react";
import { calculateEventValidity } from "./utils";

/**
 * Component for rendering previews as items are dragged.
 * The preview is determined by the rendering function stored in context.
 */
export default function DndSortOverlay() {
  const [valid, setValid] = useState(true);
  const { previewRenderer } = useDndSortContext();

  useDndMonitor({
    onDragOver(event) {
      setValid(calculateEventValidity(event));
    },
  });

  useEffect(() => {
    previewRenderer({ valid });
  }, [previewRenderer, valid]);

  const classes = cx(styles["drag-preview"], {
    [styles["can-be-dropped"]]: valid,
  });

  const preview = previewRenderer({ valid });
  if (!preview) {
    return null;
  }

  return (
    <DragOverlay className={classes}>{previewRenderer({ valid })}</DragOverlay>
  );
}
